module.exports = window["MaterialUI"].makeStyles;